module.exports = __webpack_public_path__ + "img/media__video-thumbnail.a91f6d31.svg";